export const Dropdown = {
  init() {
    this.overlayScroll();
  },
  overlayScroll() {
    $('.js-dropdown-overlay').overlayScrollbars({});
  },
};

window.addEventListener('load', () => {
  Dropdown.init();
});


// WEBPACK FOOTER //
// ./scripts/components/dropdown.js